import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import HierTable from '../HierTable';
import Spinner from '../Spinner';
import { action, toJS } from "mobx";

@inject('parameterTypeStore', 'parameterStore', 'unitStore', 'rolePermissionStore')
@observer
class ParameterTypeList extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
  }
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  };

  columns = [
    // { key: 'id', label: 'ID' },
    { key: 'name', label: 'Parameter Name', colClassName: 'level-2-indent-left' },
    { key: 'code', label: 'Code' },
    { key: 'description', label: 'Description' },
    { key: 'unit', label: 'Unit' },
  ];
  parameterColumns = [
    { key: 'id', label: 'ID' },
    { key: 'code', label: 'Code' },
    { key: 'name', label: 'Parameter Name' },
    { key: 'description', label: 'Description' },
  ];

  componentWillMount() {
    const { parameterTypeStore, parameterStore, unitStore } = this.props;
    if (!parameterTypeStore.isLoading && !parameterTypeStore.items.length) parameterTypeStore.fetchItems();
    if (!parameterStore.isLoading && !parameterStore.items.length) parameterStore.fetchItems();
    if (!unitStore.isLoading && !unitStore.items.length) unitStore.fetchItems();
  }

  @action handleDelete = (idOrIds, type) => {
    const { notify } = this.context;
    if (type === 'PARAMETER_TYPE') {
      this.props.parameterTypeStore.removeItems(idOrIds)
        .then(() => notify.success({ message: 'Deleted' }))
        .catch(err => {
          console.log(err);
          notify.error({ message: err.toString() });
        });
    }
    if (type === 'PARAMETER') {
      let parameterTypeId = this.props.parameterTypeStore.parameterStore.findById(idOrIds).parameter_type_id;
      this.props.parameterTypeStore.parameterStore.removeItems(idOrIds)
        .then(() => {
          let parameters = this.props.parameterTypeStore.items.filter(ptype => ptype.id == parameterTypeId)[0].parameters;
          let parameter = parameters.filter(p => p.id == idOrIds)[0];
          this.props.parameterTypeStore.items.filter(ptype => ptype.id == parameterTypeId)[0].parameters.splice(parameters.indexOf(parameter), 1);
          this.forceUpdate();
        })
        .then(() => notify.success({ message: 'Deleted' }))
        .catch(err => {
          console.log(err);
          notify.error({ message: err.toString() });
        });
    }
  }

  handleDeleteParameter = (idOrIds) => {
    this.props.parameterTypeStore.parameterStore.removeItems(idOrIds);
  }

  // renderChild = (rowData) => (
  // <DataTable
  // data={rowData.parameters}
  // slug={`parameter-type/${rowData.id}/parameter`}
  // parentSlug={'parameter-type'}
  // columns={this.parameterColumns}
  // onDelete={this.handleDeleteParameter}
  // />
  // )

  flattenTableData = (dataArray, canModify) => {
    const arr = [];

    dataArray.sort((a, b) => !!a.name && !!b.name && a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1).forEach(parameterType => {
      const unit = this.props.unitStore.findById(parameterType.parameter_unit_id);
      if (canModify ? true : (!!parameterType.parameters && !!parameterType.parameters.length))
        arr.push({
          type: 'PARAMETER_TYPE',
          level: 1,
          key: `type-${parameterType.id}`,
          slug: 'parameter-type',
          childSlug: `parameter-type/${parameterType.id}/parameter`,

          id: parameterType.id,
          name: parameterType.name,
          code: null,
          description: null,
          unit: !!unit && unit.name,

          data: {
            id: parameterType.id,
            name: parameterType.name,
            parameter_unit_id: parameterType.parameter_unit_id,
            unit_name: !!unit && unit.name,
            unit_symbol: !!unit && unit.symbol,
          },
        });

      parameterType &&
        parameterType.parameters &&
        parameterType.parameters.sort((a, b) => !!a.name && !!b.name && a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1).forEach(parameter => {
          arr.push({
            type: 'PARAMETER',
            level: 2,
            key: `type-${parameterType.id}-param-${parameter.id}`,
            slug: `parameter-type/${parameterType.id}/parameter`,

            id: parameter.id,
            name: parameter.name,
            code: parameter.code,
            description: parameter.description,
            unit: null,
            parent_id: parameterType.id,

            data: {
              id: parameter.id,
              code: parameter.code,
              name: parameter.name,
              description: parameter.description,
            },
          });
        });
    });

    return arr;
  };

  render() {
    const { parameterTypeStore, parameterStore, unitStore, rolePermissionStore, children } = this.props;

    if (parameterTypeStore.isLoading || parameterStore.isLoading || unitStore.isLoading) return <Spinner />;

    const canModify = rolePermissionStore.validateRole('modify parameter-type');

    return (
      <div>
        <HierTable
          data={this.flattenTableData(parameterTypeStore.items, canModify)}
          slug={'parameter-type'}
          columns={this.columns}
          onDelete={this.handleDelete}
          renderChild={this.renderChild}
          caption={'Parameter Type'}
          searchable={true}
          allowAdd
          allowDelete
          allowEdit
          resources={{ parent: 'parameter-type', child: 'parameter' }}
        />
        {children}
      </div>
    );
  }
}

export default ParameterTypeList;



// WEBPACK FOOTER //
// ./src/components/ParameterType/ParameterTypeList.js